var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',_vm._l((_vm.tasksToShow),function(cat){return (cat.tasks.length > 0)?_c('v-col',{key:cat.index},[_c('TaskListColumnVue',{attrs:{"tasks":cat.tasks,"color":cat.color,"title":cat.title}})],1):_vm._e()}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }